import { render } from "./currency.vue?vue&type=template&id=32e33ca8&scoped=true&ts=true"
import script from "./currency.vue?vue&type=script&lang=ts"
export * from "./currency.vue?vue&type=script&lang=ts"

import "./currency.vue?vue&type=style&index=0&id=32e33ca8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e33ca8"]])

export default __exports__